import React, { useState } from 'react'
import '../Style/Blog_Com.css'
import Blog_Picture from '../Blogs_Icons/18-11-97-1200x700-c-default.png'
import CalenderIcon from '../Logos/calendar.svg'
import PenIcon from '../Logos/pen-tool.svg'
import LinkIcon from '../Logos/external-link.svg'
import EyeIcon from '../Logos/eye.svg'
import RemoveIcon from '../Logos/subtract-circle-minus-remove.svg'
import EditIcon from '../Logos/edit-write.svg'
import { Link } from 'react-router-dom'

function Manage_Site_Blog_Com(Blog_Data) {
    const [BlogData, SetBlogData] = useState(Blog_Data.Blog_Data)
    return (
        <>
            <div className='manage-site-blogs-container'>
                <div className='section_control'>
                    <div className='remove-blog'>
                        <img src={RemoveIcon} />
                        <div className='hover'>حذف</div>
                    </div>
                    <div className='see-details'>
                        <img src={EyeIcon} />
                        <div className='hover'>جزئیات</div>
                    </div>
                    <div className='Edit-blog'>
                        <img src={EditIcon} />
                        <div className='hover'>تصحیح</div>
                    </div>
                    <Link to={BlogData && BlogData.link ? BlogData.link : null} className='go-to-blog'>
                        <img src={LinkIcon} />
                        <div className='hover'>رفتن به بلاگ</div>
                    </Link>
                </div>
                <div className='section_info'>
                    <div className='important-information-container'>
                        <div className='name-of-blog'>{BlogData && BlogData.title ? BlogData.title : null}</div>
                        <div className='added-date'>
                            <div className='text'>تاریخ افزودن: {BlogData && BlogData.date ? BlogData.date : null}</div>
                            <img src={CalenderIcon} className='calender-icon' />
                        </div>
                        <div className='updated-date'>
                            <div className='text'>تاریخ بروزرسانی: {BlogData && BlogData.updated_date ? BlogData.updated_date : "بروزرسانی وجود ندارد"}</div>
                            <img src={CalenderIcon} className='calender-icon' />
                        </div>
                        <div className='writer'>
                            <div className='text'>نویسنده: {BlogData && BlogData.writer ? BlogData.writer : null}</div>
                            <img src={PenIcon} className='calender-icon' />
                        </div>
                    </div>
                    <div className='blog-picture' style={{ backgroundImage: `url(${Blog_Picture})` }}></div>
                </div>
            </div>
        </>
    )
}

export default Manage_Site_Blog_Com